import gql from 'graphql-tag'

export const QueryFeedLog = gql(`query get_feed_log($auid: String!, $feed_id: ID!, $with_preview_url: Boolean) {
  getFeedLog(auid: $auid, feed_id: $feed_id, with_preview_url: $with_preview_url) {
    feed_id
    lines
    loglines {
      ok
      line
      preview_url
    }
    ok
    }
  }`)



// WEBPACK FOOTER //
// ./src/graphql/QueryFeedLog.js